<template>
  <div>
    <v-col v-if="loading" class="text-center loader-container">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-col>
    <v-row dense>
      <v-col cols="12" v-if="!loading && education">
        <education-form
          :education="education"
          :student_id="studentId"
          @save="handleSaveEducation"
          @cancel="handleCancelEducation"
          :formTitle="'Ajouter une formation'"
        ></education-form>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="!loading">
        <education-list :student_id="studentId" :hide-actions="true"></education-list>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import EducationForm from "@/components/educations/EducationForm.vue"
import EducationList from "@/components/educations/EducationList"
import Education from "@/models/Education"

export default {
  components: {
    EducationForm,
    EducationList,
  },
  async mounted() {
    this.loading = true
    this.createBlankEducation()
    this.getDataFromApi()
    if (this.educationToEdit) {
      this.education = this.educationToEdit
    } else {
      this.education = new Education()
    }
  },
  props: {
    studentId: {
      required: true,
    },
    educationToEdit: {
      default: null,
    },
  },
  data() {
    return {
      tab: null,
      education: null,
      loading: false,
      formTitle: "Inscrire un nouvel étudiant",
    }
  },
  methods: {
    async handleSaveEducation(education) {
      this.loading = true
      education.student_id = this.studentId
      if (education.id != null) {
        await Education.updateOne(education)
      } else {
        await Education.createOne(education)
      }
      this.education = new Education()
      await this.getDataFromApi()
    },
    createBlankEducation() {
      this.education = new Education()
      this.education.descriptions = this.descriptions
    },
    async getDataFromApi(val) {
      this.loading = true
      await Education.getOneByStudentId(this.studentId)
      this.loading = false
    },
    handleCancelEducation() {
      this.$emit("cancel")
    },
  },
}
</script>
<style>
.loader-container {
  height: 100%;
  min-height: 100vh;
}
</style>
